import socketAPI from "./socketAPI";
import store from "../store";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));
/**
 * ==========================================================
 * ==================== INITIALIZATION ======================
 * ==========================================================
 */

/* ====== INITALIZE NAMESPACE SOCKET COMMUNICATES TO ====== */
const NAMESPACE = "/rematch";

/* ====== SOCKET STATES ====== */
let socketNSP = null;

const rematchSocket = {
  /* ====== INITIALIZE SOCKET ====== */
  async initRematchSocket() {
    /** Custom listeners defined here because calendarSocket not available before initialization (hoisting) */
    const CUSTOM_LISTENERS = {
      "connect": rematchSocket.joinSessionRematchPool,
      "REMATCH_SUCCESSFUL": rematchSocket.handleSuccessfulRematch,
    }
    socketNSP = await socketAPI.initSocketNSP(NAMESPACE, CUSTOM_LISTENERS);
  },

  /**
   * ==========================================================
   * ======================= RECEIVERS ========================
   * ==========================================================
   */

  /* Redirect rematched user to new session */
  async handleSuccessfulRematch(data) {
    if (data && data.rematchedSession && data.rematchedSession._id) {
      data.rematchedSession.partnerIndex = 0;
      await store.dispatch("rematching/setSuccesfulRematchData", data.rematchedSession);
      await delay(3000);
      store.dispatch("session/setNewSessionID", data.rematchedSession._id);
    }
  },

  /**
   * ==========================================================
   * ======================== EMITTERS ========================
   * ==========================================================
   */

  /* ====== REMOVE ALL SOCKET EVENT LISTENERS ====== */
  exitRematchSocket() {
    rematchSocket.exitSessionRematchPool();
  },

  /**
   ** ====== ATTEMPT REQUEST A REMATCH ====== *
   *
   * @param {String} SID Session ID
   * @param {String} UID User ID
   * @param {Date} dateTimeMS dateTimeMS value of session (session start dateTime in MS)
   * @returns {Object} Returns object containing either:
   * 'rematchedSession' — if user was rematched
   * 'newRematchRequest' — if user was not rematched but a rematch request was created
   * 'requestFailedError' — in case the request failed
   */
  async requestOneRematch(SID, UID, dateTimeMS) {
    if (!SID || !UID || !dateTimeMS) {
      return console.log("Required data not provided for request.");
    }

    /* Prepare request data for sending */
    const sendData = { SID, UID, dateTimeMS };

    return await socketNSP.emit("REQUEST_ONE_REMATCH", sendData);
  },

  /* ====== ATTEMPT CANCEL ON REMATCH REQUEST ====== */
  async cancelOneRematchRequest(SID, UID) {
    if (!SID || !UID) {
      return console.log("Required data not provided for request.");
    }

    /* Prepare request data for sending */
    const sendData = { SID, UID };

    return await socketNSP.emit("CANCEL_ONE_REMATCH", sendData);
  },

  async checkExistingRematchRequest(SID, UID) {
    if (!SID || !UID) {
      return console.log("Required data not provided for request.");
    }

    /* Prepare request data for sending */
    const sendData = { SID, UID };

    return await socketNSP.emit("CHECK_EXISTING_REMATCH_REQUEST", sendData);
  },

  async joinSessionRematchPool() {
    const UID = store.getters["auth/userID"];
    if (!UID) {
      return console.log("Required data not provided for request.");
    }

    /* Prepare request data for sending */
    const sendData = { UID };

    return await socketNSP.emit("JOIN_SESSION_REMATCH_POOL", sendData);
  },

  async exitSessionRematchPool() {
    const UID = store.getters["auth/userID"];
    if (!UID) {
      return console.log("Required data not provided for request.");
    }

    /* Possibly never reaches past this because socket is already disconnected when this is called */
    if (!socketNSP.isConnected()) return console.log("socket already disconnected");

    /* Prepare request data for sending */
    const sendData = { UID };

    await socketNSP.emit("EXIT_SESSION_REMATCH_POOL", sendData);
    socketNSP.removeEventListeners();
    socketNSP = null;
  },
};

export default rematchSocket;
